import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { API } from '../../../../constants/app-service-constants';

@Injectable()
export class FavoriteBtnService {
  constructor(private http: HttpClient) {}

  addFavorite(distributionKeyCode: string): Observable<any> {
    return this.http.post(`${API.FAVORITE}/${distributionKeyCode}`, {
      distributionKeyCode,
      favorite: true,
    });
  }

  removeFavorite(distributionKeyCode: string): Observable<any> {
    return this.http.delete(`${API.FAVORITE}/${distributionKeyCode}`);
  }
}
